import type {
    GenerateSeatingPlanResponseType,
    GenerateSeatingPlanRequestType
} from "./type";
import {
    request
} from "../request";

const threeTGenerateSeatingPlan = async (args: GenerateSeatingPlanRequestType): Promise<GenerateSeatingPlanResponseType> => {
    return await request<GenerateSeatingPlanResponseType>("/threeT/generateSeatingPlan", {
        body: JSON.stringify(args),
        method: "POST"
    });
};

export default threeTGenerateSeatingPlan;
